<template>
    <div class="mx-auto col-lg-6 col-md-8 col-sm-12 header-margin pt-4">
        <div class="row state">
            <div class="col-md-2">送付先入力　→</div>
            <div class="col-md-2">個数指定　→</div>
            <div class="col-md-2">確認画面　→</div>
            <div class="col-md-2 active">お支払い</div>
        </div>

        <div class="py-3">
            <h4 class="h4 font-weight-normal text-primary text-center">
                購入代金のお支払い
            </h4>
        </div>

        <div class="text-left mt-4 border-0 card card-pricing">
            <div class="card-head">
                <h4>{{ $t('hec.payments.price') }}</h4>
            </div>
            <div class="card-body">
                <p class="card-text text-center">
                    {{ formData.total }} HEC
                </p>
            </div>
        </div>

        <div class="text-left mt-4 border-0 card card-pricing">
            <div class="card-head">
                <h4>{{ $t('hec.payments.balance') }}</h4>
            </div>
            <div class="card-body" :class="notifyClass()">
                <p class="card-text text-center">
                    <span v-if="detail.balances.hec">{{ detail.balances.hec | floor }} HEC</span>
                    <span v-else>HEC</span>
                </p>
            </div>
        </div>

        <div v-if="outOfBalance" class="row p-2 pl-4 text-danger">{{ $t('hec.payments.outOfBalance') }}</div>
        <div :class="{invisible: !requireAgree}" class="mt-2 text-center text-danger">「商品代金の送付に同意する」にチェックを入れてください。</div>

        <div class="row">
            <div class="col-12">
                <div class="col mt-2 form-check text-center">
                    <input v-model="formData.agree" name="agree" type="checkbox" class="form-check-input" id="agree">
                    <label class="form-check-label" for="agree" style="width: 180px">商品代金の送付に同意する
                    </label>
                </div>
            </div>
        </div>

        <form class="col-md-12 py-3" @submit.prevent="handleClickSubscribe">
            <div class="form-row py-3 justify-content-center">
                <div class="col-md-3">
                    <button v-on:click="handleClickBack" type="button" class="btn btn-light btn-block"
                    :disabled="!isLoaded || inProcess">{{ `戻る` }}</button>
                </div>

                <div class="col-md-3 mt-2 mt-md-0">
                    <button v-on:submit.prevent type="submit" class="btn btn-primary btn-block"
                    :disabled="!isLoaded || outOfBalance || inProcess">{{ $t('hec.policy.nextButton') }}</button>
                </div>
            </div>
        </form>

    </div>
</template>

<script>
    import orderService from "../../services/OrderService";
    import tokenService from "../../services/TokenService";
    import userService from "../../services/UserService";

    export default {
        name: 'OrderPayment',

        components: {
        },

        data() {
            return {
                formData: {
                    order_name: "",
                    order_company_name: "",
                    order_post_number_1: "",
                    order_post_number_2: "",
                    order_address_1: "",
                    order_address_2: "",
                    order_phone_number: "",
                    order_forwarding_post_number_1: "",
                    order_forwarding_post_number_2: "",
                    order_forwarding_name: "",
                    order_forwarding_company_name: "",
                    order_forwarding_post_number_1: "",
                    order_forwarding_post_number_2: "",
                    order_forwarding_address_1: "",
                    order_forwarding_address_2: "",
                    order_forwarding_phone_number: "",
                    amount: "",
                    price: "",
                    tax: "",
                    total: ""
                },
                detail: {
                    balances: {
                        hec: ''
                    }
                },
                requireAgree: false,
                isLoaded: false,
                inProcess: false,
            }
        },


        async created() {
            await this.fetchData();
        },

        methods: {

            async fetchData() {
                let [ wallet ] = await Promise.all([
                    tokenService.getWallet(),
                ]);
                this.getDefaultData();
                this.detail = wallet.data;
                this.isLoaded = true;
            },

            async getDefaultData() {
                const map = new Map(Object.entries(this.formData));

                map.forEach((value, key) => {
                    this.formData[key] = sessionStorage.getItem(key);
                });
            },

            async handleClickBack() {
                this.$router.push({ name: 'OrderConfirm' });
            },

            async handleClickSubscribe() {
                try {
                    this.requireAgree = false;
                
                    if (this.formData.agree) {
                        this.inProcess = true;
                        const result = (await orderService.payment(this.formData)).data;

                        this.$router.push('/dna/success');
                    } else {
                        this.requireAgree = true;
                    }
                } catch (error) {
                    this.inProcess = false;
                    this.$router.push('/dna/failure');
                    console.log(error);
                }
            },

            notifyClass () {
                if(this.outOfBalance) {
                    return 'card-alert';
                } else {
                    return 'card-success';
                }
            },
        },
        computed: {
            outOfBalance() {
                return Number(this.detail.balances.hec) < Number(this.formData.total);
            }
        }
    }
</script>

<style scoped>
    @import "~vodal/common.css";
    @import "~vodal/slide-down.css";

    .card-body {
        background: #efefef;
    }
    
    .card-success {
        background: #c2ffc2 !important;
    }

    .card-alert {
        background: #ff8877 !important;
    }

    .card-pricing .list-unstyled li {
        padding: .5rem 0;
        color: #6c757d;
    }
    .card-deck .card {
        flex: inherit !important;
    }
    .card-deck {
        padding: 0 0 0 10px;
    }
    .center-items {
        justify-content: center;
    }
    .hide-border {
        border-top: none !important;
    }
    .disabled-button {
        opacity: 0.5;
    }
    .form-button {
        max-width: 150px;
    }
    @media screen and (max-width: 991px) {
        .btn:hover {
            color: #fff !important;
        }
    }
    .state {
        padding-bottom: 10px;
        
        color: #888;
    }

    .state .active {
        color: #451493;
    }
</style>
